var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "v-page-pager" },
    [
      _c(
        "li",
        {
          class: [_vm.pageIndex === 1 ? "v-page-li-active" : "", "v-page-li"],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.jumpPage(1)
            },
          },
        },
        [_c("a", [_vm._v("1")])]
      ),
      _vm._v(" "),
      _vm.showJumpPrev
        ? _c(
            "li",
            {
              class: [
                _vm.pageIndex === 1 ? "disabled" : "",
                "v-page-li",
                "v-page-jump-prev",
              ],
              attrs: { title: "向前 " + _vm.showPagingCount + " 页" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.jumpPage(_vm.pageIndex - _vm.showPagingCount)
                },
              },
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.pagingCounts, function (num) {
        return _c(
          "li",
          {
            class: [
              num === _vm.pageIndex ? "v-page-li-active" : "",
              "v-page-li",
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.jumpPage(num)
              },
            },
          },
          [_c("a", [_vm._v(_vm._s(num))])]
        )
      }),
      _vm._v(" "),
      _vm.showJumpNext
        ? _c(
            "li",
            {
              staticClass: "v-page-li v-page-jump-next",
              attrs: { title: "向后 " + _vm.showPagingCount + " 页" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.jumpPage(_vm.pageIndex + _vm.showPagingCount)
                },
              },
            },
            [_vm._m(1)]
          )
        : _vm._e(),
      _vm.pageCount > 1
        ? _c(
            "li",
            {
              class: [
                _vm.pageIndex === _vm.pageCount ? "v-page-li-active" : "",
                "v-page-li",
              ],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.jumpPage(_vm.pageCount)
                },
              },
            },
            [_c("a", [_vm._v(_vm._s(_vm.pageCount))])]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [_c("i", { staticClass: "v-icon-angle-double-left" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [_c("i", { staticClass: "v-icon-angle-double-right" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }